<template>
  <div class="container">
    <Sidebar></Sidebar>

    <nav class="nav-extended blue-nav">
      <div class="nav-wrapper">
          <span class="nav-title">
            Manage content
          </span>
      </div>
      <div class="nav-content ">
         <ul class="tabs tabs-transparent "> 
           <li class="tab"><a target="_self" href="/tutorials">Tutorials</a></li> 
           <li class="tab"><a target="_self" href="/categories">Categories</a></li> 
           <li class="tab"><a target="_self" href="/quizzes">Quizzes</a></li>
           
         </ul>
         
        <button class="btn-floating btn-large halfway-fab waves-effect waves-light z-depth-3 gray-fab" v-on:click="createKnowledgeBase">
        <!-- <a href="https://dashboard.fyiio.com/#articles" class="z-depth-3 btn-floating btn-large halfway-fab waves-effect waves-light orange"> -->
          <i class="material-icons white-text">add</i>
        </button>
        
      </div>
    </nav>


    <div class="progress" v-if="loading">
      <div class="indeterminate"></div>
    </div>
    <div id="kbs" v-if="!loading">
      <div class="alert alert-danger" v-if="error">
        <p v-if="error" class="error red-text">There was an error loading knowledge bases: {{ error.message }}</p>
      </div>
      <!--
      <div v-for="(quiz, a_index) in quizzes" :key="a_index" class="row">
        <div >
          <h3 class="collection-header">{{ quiz.title }}</h3>
          -->
          <h3 class="collection-header">Knowledge Bases</h3>
          <ul class="collection s12">
            <li v-for="(item, index) in kbs" :key="'idx-'+ index" class="collection-item row valign-wrapper">
             <div class="col s11">
                <div><a class="quiz-link" v-bind:href="quizViewLink(item.id)" target="_blank">{{ item.title }}</a></div>
                  <span class='description'>{{ item.description }}</span>
                  <ul v-bind:id="'dd_'+index " class='dropdown-content'>
                    <li><a v-bind:href="'/kbs/describe/'+item.id"><i class="material-icons">mode_edit</i>Edit</a></li>
                    <li><a v-bind:href="'/kbs/results/'+item.id"><i class="material-icons">insert_chart</i>Results</a></li>
                    <li class="divider" ></li>
                    <li><a v-bind:href="'/kbs/preview/'+item.id"><i class="material-icons">check</i>Preview</a></li>
                    <li class="divider" ></li>

                    <li><a 
                      v-bind:data-id="item.id"
                      v-bind:data-title="item.title.replace(/_/g, ' ')"
                        v-on:click="deleteConfirm"
                    ><i class="material-icons">delete</i>Delete</a></li>
                  </ul>
                </div>
              <div class="col s1 right-align ">
                <a class='dropdown-trigger' href='#' v-bind:data-target="'dd_'+index" v-bind:data-link="'https://dashboard.fyiio.com/viewemb.html#tutorial/'+item.id" v-on:click="prepCopy">
                  <i class="material-icons" v-bind:data-link="'https://dashboard.fyiio.com/viewemb.html#tutorial/'+item.id">more_vert</i>
                </a>
              </div>
            </li>
          </ul>
<!--
        </div>
      </div> -->
      <div v-if="!kbs || kbs.length == 0" class="row">
        <ul class="collection s12">
          <li class="collection-item row valign-wrapper">
            <div class="col s11">
              <div>Build your first knowledge base</div>
              <span class="author">Click the dark grey circle</span>
            </div>
            <div class="col s1 right-align ">
              <i class="material-icons">arrow_upward</i>
            </div>
          </li>
        </ul>
      </div>

      <div id="copyAreaWrapper">
        <textarea id="copyArea" v-model="textToCopy"></textarea>
        <textarea id="copyLink"></textarea>
        <textarea id="copyEmbedLink"></textarea>
      </div>
    </div>

    <div id="deleteModal" class="delete-modal modal">
      <div class="modal-content">
        <h5>Are you sure you want to delete this quiz?</h5>
        <p>{{ deleteTitle }}</p>
      </div>
      <div class="modal-footer">
        <a class="modal-action modal-close waves-effect waves-grey btn-flat">Cancel</a>
        <!-- <a href="#!" class="modal-action modal-close waves-effect waves-grey btn-flat red-text">Coming Soon!</a> -->
        <a  v-on:click="deleteKnowledgeBase" class="modal-action modal-close waves-effect waves-red red-text btn-flat">Delete</a>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import cognitoAuth from '@/plugins/cognito'
import GqlV2Query from "@/plugins/gqlV2"

export default {
  mounted() {
    var self = this;
    M.AutoInit();
    cognitoAuth.getIdToken(function(err, jwttoken) {
      self.token = jwttoken;
    })
    cognitoAuth.getUserAttributes(function(err, user_attributes) {
      self.organization_id = user_attributes['custom:organization_id']
      self.user_id = user_attributes['email']
    
      let variables={
        organization_id: self.organization_id
      }
      console.log("variables:", variables)
      GqlV2Query.getKnowledgeBases(variables, (err, result) => {
            if (err) {
              console.log("get knowledge bases error:"+err);
              this.error = err;
            } else {
              console.log(JSON.stringify(result.data));
              self.kbs = result.data.knowledge_base;
              self.loading = false;
              M.AutoInit();
            }
        }
      );
    })
    
  },
  updated() {
    M.AutoInit();
  },
  name: 'KnowledgeBases',
  data () {
    return {
      token: '',
      kbs: [],
      textToCopy: '',
      embedLink: '',
      error: '',
      deleteId: '',
      deleteTitle: '',
      loading: true,
      host: window.location.host
    }
  },

  components: {
    Sidebar, cognitoAuth
  },
  methods: {
    kbViewLink(id) {
      return `https://${window.location.host}/q/${id}`
    },
    deleteConfirm(event) {
      this.deleteId = event.target.getAttribute('data-id');
      this.deleteTitle = event.target.getAttribute('data-title');
      var options = {};
      var elem = document.querySelector('.delete-modal');

      // allow time for dom to react to data change
      setTimeout(function(){
        var instance = M.Modal.init(elem, options);
        instance.open();
      }, 10)
    },
    createKnowledgeBase() {
      var self = this;
      window.location="http://localhost:8081"
    },
    deleteKnowledgeBase() {
      var self = this;
      GqlV2Query.deleteQuiz(this.deleteId, function(err, response) {
        if (err) {
          M.toast({html: 'Error deleting quiz, please try again'}, 4000)
        } else {
          if (response['errors']) {
            M.toast({html: 'Error deleting quiz, please try again'}, 4000)
          } else {
            M.toast({html: 'Successfully deleted quiz!'}, 4000)
            self.loadQuizzes();
          }
        }
      })
    },


  }
}
</script>


<style scoped>

ul.collection {
  overflow: visible;
  border:none;
}
.dropdown-content {
  min-height: 100px;
  min-width: 200px;
}
.token {
  word-break: break-all;
}
#copyAreaWrapper, #embedCode {
  position: absolute;
  left: -1000px;
}
#embedModal {
  width: 773px;
  height: 525px;
  max-height: 525px;
  font-size: 12px!important;
}
#embedModal .play i {
  padding: 40px;
  color: white;
  font-size: 50px;
  margin: 0 auto;
}
#embedModal h2 {
  font-size: 24px;
}
#embedModal .card {
  padding: 10px;
  cursor: pointer;
}
#embedModal div {
  margin-bottom: 10px;
}
#embedModal .bordered {
  border: 1px solid grey;
  height: 75px;
}
#embedModal .dashed {
  border: 1px dashed grey;
  height: 75px;
  padding: 10px;
}
.timer {
  height: 100%;
  color: grey;
  padding: 0;
}
.quiz-link {
  color: rgba(0, 0, 0, 0.87);
}
.gray-fab {
  background-color: #58595B;
}

</style>



// WEBPACK FOOTER //
// src/containers/dashboard/KnowledgeBases.vue